import "../styles/components/HeaderLogo.scss";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";
import { isMobile } from "react-device-detect";

const HeaderLogo = (props: any) => {
  return (
    <div className="header-logo">
      { isMobile ? (
        props.brand ? (
          <img
            alt="logo"
            src="/elsevier_logo.svg"
            className="mb-2"
          />
        ) : (
          <>
            <img
              alt="logo"
              src="/DIISHA_Mobile.png"
              className="mb-2"
            />
            <img
              alt="logo"
              src="/CPPC_Mobile.svg"
              className="mb-2 left-border"
            />
          </>
        )
      ) : (
        props.brand ? (
          <img
            alt="logo"
            src="/elsevier_logo_desktop.svg"
            className="mb-2"
          />
        ) : (
          <>
            <img
              alt="logo"
              src="/DIISHA_Desktop.png"
              className="mb-2"
            />
            <img
              alt="logo"
              src="/CPPC_Desktop.svg"
              className="mb-2 left-border"
            />
          </>
        )
      )}
    </div>
  )
}
export default ErrorBoundaryHandler(HeaderLogo);
